// extracted by mini-css-extract-plugin
export default {"element":"LinkButton_element__IsWBB","linkWrapper":"LinkButton_linkWrapper__S6AfV"};